import { styled, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Flex from 'ui/Flex/Flex';
import ScopesAndProtections from './ScopesProtectionsConfiguration/ScopesAndProtections';
import TransfertMappings from './TransfertMappings/TransfertMappings';

const StyItem = styled(Flex, { name: 'StyItem' })(({ theme }) => ({
    padding: theme.spacing(2),
}));

const MappingAndScopes = ({ bind }: { bind: string }) => {
    const { t } = useTranslation();
    return (
        <Flex gap={2} margin={2} direction="column" justify="space-between">
            <StyItem direction="column">
                <Typography variant="h4">{t('support.mappings')}</Typography>
                <TransfertMappings selectedBind={bind} />
            </StyItem>
            <StyItem direction="column">
                <Typography variant="h4">
                    {t('support.scopes.titleScope')}
                </Typography>
                <ScopesAndProtections selectedBind={bind} />
            </StyItem>
        </Flex>
    );
};

export default React.memo(MappingAndScopes);
